import React, { memo, useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { useShallowEqualSelector } from 'custom-hooks'
import {
  getEquipmentSelectedDateRangeSelector,
  setEquipmentSelectedDateRange,
} from 'redux/reducers/equipments'
import DateRangeFilter from 'components/DateRangeFilter/DateRangeFilter'

const DateRangeFilterSection = () => {
  const dispatch = useDispatch()
  const selectedDateRange = useShallowEqualSelector(
    getEquipmentSelectedDateRangeSelector
  )

  const handleChangeDateRange = useCallback(
    (values) => {
      dispatch(setEquipmentSelectedDateRange(values))
    },
    [dispatch]
  )

  return (
    <DateRangeFilter
      selectedDateRange={selectedDateRange}
      handleChange={handleChangeDateRange}
      className="equpment_filter_date_range_container"
    />
  )
}

export default memo(DateRangeFilterSection)
